import PageLayout from '../components/pageLayout';
import UsersList from '../components/UsersList';

function UsersListPage() {
    return (
        <PageLayout children={<UsersList />} />
    );
}

export default UsersListPage;
